<template>
  <form @submit.prevent="submit">
  <h6>Name:</h6>

  <div class="row mb-4">
    <div class="col-6">
      <div class="input firstname">
        <input type="text" class="firstname" name="firstname" :id="`driver-firstname-${uid}`" v-model.lazy="payload.firstname" required>
        <label :for="`driver-firstname-${uid}`">Firstname</label>
      </div>
    </div>
    <div class="col-6">
      <div class="input surname">
        <input type="text" class="surname" name="surname" :id="`driver-surname-${uid}`" v-model.lazy="payload.surname" required>
        <label :for="`driver-surname-${uid}`">Surname</label>
      </div>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-12">
      <div class="input email">
        <input type="email" class="email" name="email" :id="`driver-email-${uid}`" v-model.lazy="payload.email" required>
        <label :for="`driver-email-${uid}`">Email</label>
      </div>
    </div>
  </div>

  <div v-if="payload.driverID" class="row mb-4">
    <div class="col-12">
      <div class="input address">
        <input type="text" class="address" name="address" :id="`driver-address-${uid}`" v-model.lazy="payload.address" required>
        <label :for="`driver-address-${uid}`">Address</label>
      </div>
    </div>
  </div>

  <div v-if="payload.driverID" class="row mb-4">
    <div class="col-12">
      <div class="input postcode">
        <input type="text" class="postcode" name="postcode" :id="`driver-postcode-${uid}`" v-model.lazy="payload.postcode" required>
        <label :for="`driver-postcode-${uid}`">Postcode</label>
      </div>
    </div>
  </div>

  <div v-if="payload.driverID" class="row mb-4">
    <div class="col-12">
      <div class="input mobile-phone">
        <input type="text" class="mobile-phone" name="mobile_phone" :id="`driver-mobile-phone-${uid}`" v-model.lazy="payload.mobilePhone" required>
        <label :for="`driver-mobile-phone-${uid}`">Mobile Phone</label>
      </div>
    </div>
  </div>

  <div v-if="showDrivingLicense" class="row mb-4">
    <div class="col-12">
      <div class="input driving-license">
        <input type="text" class="driving-license" name="driving_license" :id="`driver-driving-license-${uid}`" v-model.lazy="payload.drivingLicense" required>
        <label :for="`driver-driving-license-${uid}`">Driving License #:</label>
      </div>
    </div>
  </div>

  <div v-if="payload.driverID && allowTaxBandSelection" class="row mb-4">
    <div class="col-12">
      <div class="custom-multiselect">
        <label for="driver-profile-tax-band">Tax Band (%)</label>
        <multiselect
          id="driver-profile-tax-band"
          v-model="payload.taxBand"
          :options="taxBandsOptions"
          group-values="options"
          group-label="group"
          :group-select="false"
          :show-labels="false"
        >
        </multiselect>
      </div>
    </div>
  </div>

  <div class="text-right">
    <button v-if="payload.additionalDriverID" type="button" class="button button--remove me-2" @click="confirmDelete">Delete Driver</button>
    <input type="submit" value="Save" class="button button--steelBlue">
  </div>
  </form>
</template>

<script setup>
import {reactive, computed, watch, getCurrentInstance} from 'vue';
import Multiselect from "vue-multiselect";
import {isTaxBandSelectionAllowed} from "@/helpers/utils";

const uid = getCurrentInstance().uid;
const taxBandsOptions = [
  {
    group: 'Tax Rates',
    options: [20, 40, 45]
  },
];

const props = defineProps({
  driver: {
    type: Object,
    required: true,
  },
  product: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['save', 'delete', 'percent-updated']);

const payload = reactive(JSON.parse(JSON.stringify(props.driver)));

// Percentage calculation based on live form state (payload)
// Text inputs use v-model.lazy so percent updates on blur
// Multiselect updates on selection change
const isFilled = v => v !== null && v !== undefined && v !== '' && v !== false;

const showDrivingLicense = computed(() => {
  return props.product.display_settings_show_driving_license_main_driver;
})

// When disabled, the tax band comes from the Jaama driver profile and is left off the form
const allowTaxBandSelection = computed(() => isTaxBandSelectionAllowed(props.product));

const percent = computed(() => {
  const d = payload;
  const basic = [d.firstname, d.surname, d.email];
  if (showDrivingLicense.value) basic.push(d.drivingLicense);
  const employee = d.driverID ? [d.address, d.postcode, d.mobilePhone] : [];
  // The driver can't set a read-only tax band, so it doesn't count towards completion
  if (d.driverID && allowTaxBandSelection.value) employee.push(d.taxBand);
  const allFields = [...basic, ...employee];

  const filled = allFields.filter(isFilled).length;
  return Math.round((filled / allFields.length) * 100);
});

watch(percent, val => emit('percent-updated', val), { immediate: true });

function confirmDelete() {
  if (confirm('Are you sure you want to delete this driver?')) {
    emit('delete', payload);
  }
}

function submit() {
  const submitPayload = {...payload};
  if (!allowTaxBandSelection.value) {
    delete submitPayload.taxBand;
  }
  emit('save', submitPayload);
}
</script>

<style scoped>

</style>
